export type SpecialGroup = {
  title: string;
  description: string;
  articleIds: string[];
};

export type Special = {
  id: string;
  title: string;
  cover: string;
  intro: string;
  date: string;
  groups: SpecialGroup[];
};

export const specials: Special[] = [
  {
    id: "sp-plot",
    title: "剧情深度解读专题",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20rain%20streaked%20glass%20with%20blue%20city%20bokeh%20and%20warm%20orange%20lights%20behind%2C%20moody%20analytical%20atmosphere%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1200&height=675&seq=fm3-sp-01&orientation=landscape",
    intro:
      "本专题汇集对《朋友的妈妈3》剧情的深度解读，从影像符号、台词结构到人物动机，帮助观众更完整地理解这部作品的叙事设计。",
    date: "2026-10-13",
    groups: [
      {
        title: "影像与符号",
        description: "从雨、光、空间等视觉元素切入，拆解作品的镜头语言。",
        articleIds: ["news-02", "news-09"],
      },
      {
        title: "台词与结构",
        description: "梳理关键台词与叙事结构，看懂那些藏在对白里的线索。",
        articleIds: ["news-06", "news-10"],
      },
    ],
  },
  {
    id: "sp-character",
    title: "角色档案专题",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20restrained%20portrait%20of%20a%20woman%20in%20deep%20blue%20shadow%20with%20warm%20orange%20rim%20light%2C%20emotional%20cinematic%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1200&height=675&seq=fm3-sp-02&orientation=landscape",
    intro:
      "本专题聚焦《朋友的妈妈3》的核心人物，梳理他们的动机、关系与成长弧线，帮助你真正看懂每一个人。",
    date: "2026-10-11",
    groups: [
      {
        title: "主角群像",
        description: "程野、苏晚晴、程母——三条彼此缠绕的人物线。",
        articleIds: ["news-03", "news-01"],
      },
    ],
  },
  {
    id: "sp-official",
    title: "官方资讯专题",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20production%20schedule%20board%20and%20clapperboard%20under%20warm%20light%20with%20deep%20blue%20background%2C%20organized%20official%20mood%2C%20artistic%2C%20no%20text%2C%20high%20detail&width=1200&height=675&seq=fm3-sp-03&orientation=landscape",
    intro:
      "官方发布与制作动态集中地：预告、播出排期、答疑与幕后特辑，一站获取权威信息。",
    date: "2026-10-12",
    groups: [
      {
        title: "官方发布",
        description: "来自官方的定档、更新与答疑信息。",
        articleIds: ["news-04", "news-08", "news-01"],
      },
      {
        title: "幕后制作",
        description: "走进摄制组，了解画面与声音背后的故事。",
        articleIds: ["news-05", "news-07"],
      },
    ],
  },
];